import {initElements} from "../define/shared"
import Splide from '@splidejs/splide'

export default function initSingleProduct() {
    initElements(".singleProduct", singleProduct => {
        const splide = singleProduct.querySelector('.relatedPosts')
        const productTabs = singleProduct.querySelector('.productTabs')

        if (productTabs) {
            const tabs = productTabs.querySelectorAll('.productTabs-item'),
                links = productTabs.querySelectorAll('.ph-btn')

            tabs.forEach(tab => {
                tab.addEventListener('click', () => {
                    tabs.forEach(item => item.classList.remove('is--active'))
                    tab.classList.add('is--active')
                    links.forEach(item => item.style.display = 'none')
                    productTabs.querySelector(`[data-product-link="${tab.dataset.id}"]`).style.display = 'block'
                })
            })
        }

        new Splide(splide, {
            arrows: false,
            speed: 1000,
            interval: 8000,
            pagination: true,
            perPage: 5,
            autoplay: true,
            // type: 'loop',
            gap: '1.5rem',
            breakpoints: {
                1200: {
                    perPage: 4,
                    gap: '1rem',
                },
                900: {
                    perPage: 3,
                },
                700: {
                    perPage: 2,
                    gap: '10px',
                },
                440: {
                    perPage: 1,
                },
            }
        }).mount()
    })
}
